import { BiSolidBarChartAlt2, BiSolidDashboard } from 'react-icons/bi';
import { RiServerFill, RiEqualizerFill } from 'react-icons/ri';
import { GrTransaction } from 'react-icons/gr';
import {
  MdDomainVerification,
  MdAccountCircle,
  MdSupervisorAccount,
  MdOutlineHistory,
  MdPayments,
} from 'react-icons/md';
import { FcAbout } from 'react-icons/fc';

const sideBarArrprimary = [
  { id: 1, icon: <BiSolidDashboard />, name: 'Dashboard', path: 'dashboard' },
  {
    id: 2,
    icon: <BiSolidBarChartAlt2 />,
    name: 'Trade Currency',
    path: 'tradecurrency',
  },
  {
    id: 3,
    icon: <RiServerFill />,
    name: 'Transaction Request',
    path: 'transactionrequest',
  },
  { id: 4, icon: <GrTransaction />, name: 'Place Order', path: 'placeorder' },
  {
    id: 5,
    icon: <MdOutlineHistory />,
    name: 'Transaction History',
    path: 'transactionhistory',
  },
  {
    id: 6,
    icon: <MdPayments />,
    name: 'Payment Methods',
    path: 'paymentmethod',
  },
];

const sideBarArrsecondary = [
  {
    id: 1,
    icon: <MdDomainVerification />,
    name: 'Subscription',
    path: 'subscription',
  },
  {
    id: 2,
    icon: <MdSupervisorAccount />,
    name: 'Refferrer',
    path: 'referrer',
  },

  { id: 3, icon: <RiEqualizerFill />, name: 'Settings', path: 'settings' },
];
export default { sideBarArrprimary, sideBarArrsecondary };
